export default __webpack_public_path__ + "static/media/Assistant.d001a544.jpg";